import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

const contactEmail = "workwithdilip1@gmail.com";

const cookieTypes = [
    ["Essential cookies", "Used for basic site operation, routing, form state, security checks, and remembering choices required for the service to work."],
    ["Preference cookies", "Used to remember non-essential choices such as interface preferences, region, or consent settings when those features are available."],
    ["Analytics cookies", "May be used to understand aggregate site performance, broken flows, waitlist conversion, and feature interest. We should avoid using these to identify individuals unnecessarily."],
    ["Marketing cookies", "Not currently required for the core experience. If introduced, they should be opt-in where required and explained before use."],
];

export default function Cookies() {
    useReveal();

    return (
        <div className="relative min-h-screen overflow-x-hidden" data-testid="cookies-page">
            <div className="grain" />
            <Header />
            <main id="top">
                <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28 bg-[var(--paper)]">
                    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
                        <div className="reveal in stamp stamp-large mb-8">
                            Cookie notice
                        </div>
                        <h1 className="reveal in font-display text-[18vw] sm:text-[12vw] lg:text-[10rem] leading-[0.82] tracking-tighter">
                            Cookies, but{" "}
                            <span className="font-italic-serif text-[var(--hot)]">
                                plain.
                            </span>
                        </h1>
                        <p className="reveal in mt-8 max-w-2xl text-lg leading-relaxed text-[var(--ink-soft)]">
                            This page explains what cookies and similar technologies
                            may be used for on the LÜVYN website and future app.
                        </p>
                    </div>
                </section>

                <section className="relative py-20 lg:py-28 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]">
                    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid gap-5">
                        {cookieTypes.map(([title, copy], index) => (
                            <article
                                key={title}
                                className="reveal grid lg:grid-cols-[120px_0.6fr_1fr] gap-5 bg-[var(--paper)] border-2 border-[var(--ink)] p-7 items-start"
                            >
                                <div className="font-display text-5xl text-[var(--hot)]">
                                    {String(index + 1).padStart(2, "0")}
                                </div>
                                <h2 className="font-display text-3xl lg:text-4xl leading-tight">
                                    {title}
                                </h2>
                                <p className="leading-relaxed text-[var(--ink-soft)]">
                                    {copy}
                                </p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="relative py-20 lg:py-28">
                    <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
                        <div className="reveal border-y-2 border-[var(--ink)] py-10">
                            <h2 className="font-display text-5xl lg:text-7xl leading-[0.9]">
                                How to control cookies.
                            </h2>
                            <p className="mt-6 leading-relaxed text-[var(--ink-soft)] max-w-3xl">
                                You can usually block or delete cookies in your
                                browser settings. Some essential features may stop
                                working if essential cookies are disabled. For
                                cookie questions, contact{" "}
                                <a className="text-[var(--hot)]" href={`mailto:${contactEmail}`}>
                                    {contactEmail}
                                </a>
                                .
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
